import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tooltip from "../../../components/Tooltip/Tooltip";
import AccordionHeaderInfoIcon from "./AccordionHeaderInfoIcon";
import { getAccordionHeaderTooltipMaxWidth } from "./accordionHeaderTooltip";

const AccordionHeaderLabel = ({ title, tooltip, theme, isSelected, sx }) => {
  const infoIcon = (
    <AccordionHeaderInfoIcon
      theme={theme}
      title={tooltip}
      isSelected={isSelected}
    />
  );

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        ...sx,
      }}
    >
      <Typography
        component="span"
        color={theme.colors.fontColor}
        fontSize={theme.fontSizes.normal}
        fontFamily={theme.fonts.regular}
        sx={{
          lineHeight: 1,
          display: "inline-flex",
          alignItems: "center",
          fontWeight: isSelected
            ? theme.fontWeight.titleWeight
            : theme.fontWeight.normal,
        }}
      >
        {title}
      </Typography>
      {tooltip ? (
        <Tooltip
          content={tooltip}
          position="bottom"
          maxWidth={getAccordionHeaderTooltipMaxWidth(tooltip)}
          delay={100}
          style={{ display: "inline-flex" }}
        >
          {infoIcon}
        </Tooltip>
      ) : (
        infoIcon
      )}
    </Box>
  );
};

export default AccordionHeaderLabel;
